import { UseQueryOptions } from 'react-query';
import { useCustomMutate, useCustomQuery } from '../../../../../hooks/query';
import {
  GET_ORG_ADMIN_RESULT_RELEASE_BY_INDEX_NO,
  POST_BULK_DOWNLOAD_ORG_ADMIN_RESULT_RELEASE,
  POST_ORG_ADMIN_RESULT_RELEASE_SEARCH_PARAM,
} from './keys';
import {
  getIndividualResultReleaseByIndexNo,
  postBulkUploadData,
  postSearchResultRelease,
} from '../api-services/api';
import { ServiceError } from '../../../../../hooks/error';
import {
  CandidatePsleResultReleaseSchema,
  CandidateResultReleaseSchema,
} from '../../../../../models/@candidate/CandidateResultReleaseSchema';
import { BulkDownloadOrgAdminResultReleaseResponse } from '../models';

/** to get org admin candidate result release by search params
 * @returns OrgAdminResultReleaseResponse
 * */
export const usePostOrgAdminResultReleaseSearchParam = (
  successCallback: (res: any) => void,
  failCallback: (res: any) => void
) =>
  useCustomMutate(
    POST_ORG_ADMIN_RESULT_RELEASE_SEARCH_PARAM,
    postSearchResultRelease,
    {
      onSuccess: (res) => successCallback(res),
      onError: (err) => failCallback(err),
    },
    false,
    false
  );

/** to get org admin candidate result release by index no
 * @returns CandidateResultReleaseSchema
 * */
export const useGetOrgAdminResultReleaseByIndexNo = (
  indexNo: string,
  queryOptions?:
    | UseQueryOptions<CandidateResultReleaseSchema | CandidatePsleResultReleaseSchema, ServiceError>
    | undefined
) =>
  useCustomQuery<CandidateResultReleaseSchema | CandidatePsleResultReleaseSchema>(
    GET_ORG_ADMIN_RESULT_RELEASE_BY_INDEX_NO,
    () => getIndividualResultReleaseByIndexNo(indexNo).then((res) => res.data),
    queryOptions,
    false,
    false
  );

/** to post bulk download data
 * @returns CandidateResultReleaseSchema
 * */
export const usePostBulkDownloadOrgAdminResultRelease = (
  successCallback: (res: BulkDownloadOrgAdminResultReleaseResponse) => void,
  failCallback: (res: any) => void
) =>
  useCustomMutate(
    POST_BULK_DOWNLOAD_ORG_ADMIN_RESULT_RELEASE,
    postBulkUploadData,
    {
      onSuccess: (res) => successCallback(res.data),
      onError: (err) => failCallback(err),
    },
    false,
    false
  );
